<template>
<div class="chapter">
<div class="inner_page">
<div id="fm5">
<p class="dedication">To Cleo — whose contribution is</p>
<p class="dedication1">greater than she knows</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?7dd118a8